import React, { useState, useEffect, useRef } from 'react';
import { Tooltip, Typography, Box, tooltipClasses, styled } from '@mui/material';
import { RedTheme } from 'common/global';
import { useScreen } from 'common/hooks/useScreen';

let redtheme = RedTheme;

const HtmlTooltipCss = {
  backgroundColor: redtheme.palette.tooltip.white,
  color: redtheme.palette.tooltip.black_gray,
  fontSize: '14px',
  boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.24)',
  border: `1px solid ${redtheme.palette.tooltip.white}`,
  borderRadius: '16px',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  padding: '20px',
  gap: '8px',
};

const HtmlTooltipArrowCss = {
  color: redtheme.palette.tooltip.white,
}

const CustomHtmlTooltipCss = {
  ...HtmlTooltipCss
};

const CustomHtmlTooltipArrowCss = {
  ...HtmlTooltipArrowCss
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: HtmlTooltipArrowCss,
  [`& .${tooltipClasses.tooltip}`]: HtmlTooltipCss,
}));

const CustomHtmlTooltip = function ({ className, tooltipCss = {}, tooltipArrowCss = {}, ...props }) {
  return (
    <Tooltip
      {...props}
      arrow
      classes={{ popper: className }}
      componentsProps={{
        tooltip: {
          sx: {
            ...CustomHtmlTooltipCss,
            '& .MuiTooltip-arrow': {
              ...CustomHtmlTooltipArrowCss,
              ...(tooltipArrowCss || {}) // to override the default written css with our custom css
            },
            ...(tooltipCss || {}) // to override the default written css with our custom css
          }
        },
      }}
    />
  );
};

export const ToolTipWrapper = ({ title, placement, header, children, isOnlyText = false, isCustomHtmlTooltip = false, tooltipCss={}, tooltipArrowCss={}}) => {
  const screen = useScreen(); 
  const [isToolTipOpen,setIsToolTipOpen] = useState(false); 
  const tooltipRef = useRef(null);
  const toolTipTitle = () => {
    return (<>
          <Typography
            variant='body1'
            sx={{
              fontFamily: '"JohnsonText-Bold"',
              color: redtheme.palette.tooltip.black,
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '16px',
              marginBottom: '8px',
            }}
          >
            {header}
          </Typography>
          <Typography
            sx={{
              fontFamily: '"JohnsonText-Light"',
              color: redtheme.palette.tooltip.black_gray,
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '16px',
              marginBottom: '8px',
            }}
          >
            {title}
          </Typography>
        </>)
  }
  const toolTipBody = () => {
    return (<Box sx={{ color: redtheme.palette.tooltip.black_gray, fontSize: 14 }}>
        <Typography
          sx={{
            color: redtheme.palette.tooltip.black_gray,
            fontSize: screen.isDesktop? '16px' : '14px',
            lineHeight: screen.isDesktop? '18px': '14px',
            fontFamily: '"JohnsonText-Regular"',
            fontWeight: 500,
          }}
        >
          {children}
        </Typography>
      </Box>)
  }
  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setIsToolTipOpen(false);
    }
  };
   useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return isCustomHtmlTooltip ? (
    screen.isDesktop ? (
      <CustomHtmlTooltip
        placement={placement}
        title={toolTipTitle()}
        arrow
        tooltipCss={tooltipCss || {}}
        tooltipArrowCss={tooltipArrowCss || {}}
      >
        {isOnlyText ? children : toolTipBody()}
      </CustomHtmlTooltip>
    ) : (
      <div ref={tooltipRef}>
        <CustomHtmlTooltip
          placement={placement}
          title={toolTipTitle()}
          onClose={() => setIsToolTipOpen(false)}
          onClick={() => setIsToolTipOpen(!isToolTipOpen)}
          open={isToolTipOpen}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          arrow
          tooltipCss={tooltipCss || {}}
          tooltipArrowCss={tooltipArrowCss || {}}
        >
          {isOnlyText ? children : toolTipBody()}
        </CustomHtmlTooltip>
      </div>
    )
  ) : screen.isDesktop ? (
    <HtmlTooltip placement={placement} title={toolTipTitle()} arrow>
      {toolTipBody()}
    </HtmlTooltip>
  ) : (
    <div ref={tooltipRef}>
      <HtmlTooltip
        placement={placement}
        title={toolTipTitle()}
        onClose={() => setIsToolTipOpen(false)}
        onClick={() => setIsToolTipOpen(!isToolTipOpen)}
        open={isToolTipOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        arrow
      >
        {toolTipBody()}
      </HtmlTooltip>
    </div>
  ); 
};
